export default __webpack_public_path__ + "static/media/NDSLogo.3979e154.png";